import * as i0 from '@angular/core';
import { Injectable } from '@angular/core';
import * as i1 from '@angular/common/http';
import { HttpHeaders } from '@angular/common/http';
import { map } from 'rxjs/operators';

// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// Enums.
// *********************************
var ReviewRequestStatus = /*#__PURE__*/function (ReviewRequestStatus) {
  ReviewRequestStatus[ReviewRequestStatus["LEFT_REVIEW"] = 0] = "LEFT_REVIEW";
  ReviewRequestStatus[ReviewRequestStatus["DELIVERED"] = 1] = "DELIVERED";
  ReviewRequestStatus[ReviewRequestStatus["BOUNCED"] = 2] = "BOUNCED";
  ReviewRequestStatus[ReviewRequestStatus["OPENED"] = 3] = "OPENED";
  ReviewRequestStatus[ReviewRequestStatus["CLICKED"] = 4] = "CLICKED";
  ReviewRequestStatus[ReviewRequestStatus["CLICKED_POSITIVE"] = 5] = "CLICKED_POSITIVE";
  ReviewRequestStatus[ReviewRequestStatus["CLICKED_NEGATIVE"] = 6] = "CLICKED_NEGATIVE";
  ReviewRequestStatus[ReviewRequestStatus["UNSUBSCRIBE"] = 7] = "UNSUBSCRIBE";
  ReviewRequestStatus[ReviewRequestStatus["SPAM_REPORT"] = 8] = "SPAM_REPORT";
  ReviewRequestStatus[ReviewRequestStatus["SENDING"] = 9] = "SENDING";
  ReviewRequestStatus[ReviewRequestStatus["DROPPED"] = 10] = "DROPPED";
  return ReviewRequestStatus;
}(ReviewRequestStatus || {});
var SortDirection = /*#__PURE__*/function (SortDirection) {
  SortDirection[SortDirection["Ascending"] = 0] = "Ascending";
  SortDirection[SortDirection["Descending"] = 1] = "Descending";
  return SortDirection;
}(SortDirection || {});
var SortField = /*#__PURE__*/function (SortField) {
  SortField[SortField["Name"] = 0] = "Name";
  SortField[SortField["Created"] = 1] = "Created";
  return SortField;
}(SortField || {});
// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// Enums.
// *********************************
var CustomerFieldType = /*#__PURE__*/function (CustomerFieldType) {
  CustomerFieldType[CustomerFieldType["CUSTOMER_FIELD_TYPE_NONE"] = 0] = "CUSTOMER_FIELD_TYPE_NONE";
  CustomerFieldType[CustomerFieldType["CUSTOMER_FIELD_TYPE_EMAIL"] = 1] = "CUSTOMER_FIELD_TYPE_EMAIL";
  CustomerFieldType[CustomerFieldType["CUSTOMER_FIELD_TYPE_PHONE"] = 2] = "CUSTOMER_FIELD_TYPE_PHONE";
  return CustomerFieldType;
}(CustomerFieldType || {});
var CustomerSortDirection = /*#__PURE__*/function (CustomerSortDirection) {
  CustomerSortDirection[CustomerSortDirection["CUSTOMER_SORT_DIRECTION_ASCENDING"] = 0] = "CUSTOMER_SORT_DIRECTION_ASCENDING";
  CustomerSortDirection[CustomerSortDirection["CUSTOMER_SORT_DIRECTION_DESCENDING"] = 1] = "CUSTOMER_SORT_DIRECTION_DESCENDING";
  return CustomerSortDirection;
}(CustomerSortDirection || {});
var CustomerSortField = /*#__PURE__*/function (CustomerSortField) {
  CustomerSortField[CustomerSortField["CUSTOMER_SORT_FIELD_FIRST_NAME"] = 0] = "CUSTOMER_SORT_FIELD_FIRST_NAME";
  CustomerSortField[CustomerSortField["CUSTOMER_SORT_FIELD_LAST_NAME"] = 1] = "CUSTOMER_SORT_FIELD_LAST_NAME";
  CustomerSortField[CustomerSortField["CUSTOMER_SORT_FIELD_CREATED"] = 2] = "CUSTOMER_SORT_FIELD_CREATED";
  return CustomerSortField;
}(CustomerSortField || {});
var CustomerValidationError = /*#__PURE__*/function (CustomerValidationError) {
  CustomerValidationError[CustomerValidationError["CUSTOMER_VALIDATION_ERROR_NO_ERRORS"] = 0] = "CUSTOMER_VALIDATION_ERROR_NO_ERRORS";
  CustomerValidationError[CustomerValidationError["CUSTOMER_VALIDATION_ERROR_EMAIL_OR_PHONE_REQUIRED"] = 1] = "CUSTOMER_VALIDATION_ERROR_EMAIL_OR_PHONE_REQUIRED";
  CustomerValidationError[CustomerValidationError["CUSTOMER_VALIDATION_ERROR_INVALID_EMAIL"] = 2] = "CUSTOMER_VALIDATION_ERROR_INVALID_EMAIL";
  CustomerValidationError[CustomerValidationError["CUSTOMER_VALIDATION_ERROR_INVALID_PHONE"] = 3] = "CUSTOMER_VALIDATION_ERROR_INVALID_PHONE";
  CustomerValidationError[CustomerValidationError["CUSTOMER_VALIDATION_ERROR_INVALID_FIRST_NAME"] = 4] = "CUSTOMER_VALIDATION_ERROR_INVALID_FIRST_NAME";
  CustomerValidationError[CustomerValidationError["CUSTOMER_VALIDATION_ERROR_INVALID_LAST_NAME"] = 5] = "CUSTOMER_VALIDATION_ERROR_INVALID_LAST_NAME";
  return CustomerValidationError;
}(CustomerValidationError || {});
var EntityType = /*#__PURE__*/function (EntityType) {
  EntityType[EntityType["ENTITY_TYPE_UNKNOWN"] = 0] = "ENTITY_TYPE_UNKNOWN";
  EntityType[EntityType["ENTITY_TYPE_CUSTOMER"] = 1] = "ENTITY_TYPE_CUSTOMER";
  EntityType[EntityType["ENTITY_TYPE_CONFLICT"] = 2] = "ENTITY_TYPE_CONFLICT";
  return EntityType;
}(EntityType || {});
// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// Enums.
// *********************************
var CustomerType = /*#__PURE__*/function (CustomerType) {
  CustomerType[CustomerType["CUSTOMER_TYPE_UNKNOWN"] = 0] = "CUSTOMER_TYPE_UNKNOWN";
  CustomerType[CustomerType["CUSTOMER_TYPE_CUSTOMER"] = 1] = "CUSTOMER_TYPE_CUSTOMER";
  CustomerType[CustomerType["CUSTOMER_TYPE_CONFLICT"] = 2] = "CUSTOMER_TYPE_CONFLICT";
  return CustomerType;
}(CustomerType || {});
// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// Enums Index.
// *********************************

function enumStringToValue$4(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class FieldMask {
  static fromProto(proto) {
    let m = new FieldMask();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.paths !== 'undefined') {
      toReturn['paths'] = this.paths;
    }
    return toReturn;
  }
}
function enumStringToValue$3(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class AddUsersToListRequest {
  static fromProto(proto) {
    let m = new AddUsersToListRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.listId !== 'undefined') {
      toReturn['listId'] = this.listId;
    }
    if (typeof this.userIds !== 'undefined') {
      toReturn['userIds'] = this.userIds;
    }
    return toReturn;
  }
}
class AssociateIDRequest {
  static fromProto(proto) {
    let m = new AssociateIDRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.contactId !== 'undefined') {
      toReturn['contactId'] = this.contactId;
    }
    if (typeof this.vendorContactId !== 'undefined') {
      toReturn['vendorContactId'] = this.vendorContactId;
    }
    if (typeof this.appId !== 'undefined') {
      toReturn['appId'] = this.appId;
    }
    return toReturn;
  }
}
class BulkCreateContactRequest {
  static fromProto(proto) {
    let m = new BulkCreateContactRequest();
    m = Object.assign(m, proto);
    if (proto.mapping) {
      m.mapping = HeaderMapping.fromProto(proto.mapping);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.filePath !== 'undefined') {
      toReturn['filePath'] = this.filePath;
    }
    if (typeof this.mapping !== 'undefined' && this.mapping !== null) {
      toReturn['mapping'] = 'toApiJson' in this.mapping ? this.mapping.toApiJson() : this.mapping;
    }
    if (typeof this.syncedAppIds !== 'undefined') {
      toReturn['syncedAppIds'] = this.syncedAppIds;
    }
    if (typeof this.permissionToContact !== 'undefined') {
      toReturn['permissionToContact'] = this.permissionToContact;
    }
    return toReturn;
  }
}
class BulkUpdateContactRequest {
  static fromProto(proto) {
    let m = new BulkUpdateContactRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.contactIds !== 'undefined') {
      toReturn['contactIds'] = this.contactIds;
    }
    if (typeof this.syncedAppIdsToAdd !== 'undefined') {
      toReturn['syncedAppIdsToAdd'] = this.syncedAppIdsToAdd;
    }
    if (typeof this.syncedAppIdsToRemove !== 'undefined') {
      toReturn['syncedAppIdsToRemove'] = this.syncedAppIdsToRemove;
    }
    if (typeof this.permissionToContact !== 'undefined') {
      toReturn['permissionToContact'] = this.permissionToContact;
    }
    if (typeof this.accountGroupId !== 'undefined') {
      toReturn['accountGroupId'] = this.accountGroupId;
    }
    return toReturn;
  }
}
class Contact {
  static fromProto(proto) {
    let m = new Contact();
    m = Object.assign(m, proto);
    if (proto.created) {
      m.created = new Date(proto.created);
    }
    if (proto.updated) {
      m.updated = new Date(proto.updated);
    }
    if (proto.deleted) {
      m.deleted = new Date(proto.deleted);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.contactId !== 'undefined') {
      toReturn['contactId'] = this.contactId;
    }
    if (typeof this.accountGroupId !== 'undefined') {
      toReturn['accountGroupId'] = this.accountGroupId;
    }
    if (typeof this.firstName !== 'undefined') {
      toReturn['firstName'] = this.firstName;
    }
    if (typeof this.lastName !== 'undefined') {
      toReturn['lastName'] = this.lastName;
    }
    if (typeof this.address !== 'undefined') {
      toReturn['address'] = this.address;
    }
    if (typeof this.city !== 'undefined') {
      toReturn['city'] = this.city;
    }
    if (typeof this.state !== 'undefined') {
      toReturn['state'] = this.state;
    }
    if (typeof this.country !== 'undefined') {
      toReturn['country'] = this.country;
    }
    if (typeof this.phone !== 'undefined') {
      toReturn['phone'] = this.phone;
    }
    if (typeof this.email !== 'undefined') {
      toReturn['email'] = this.email;
    }
    if (typeof this.created !== 'undefined' && this.created !== null) {
      toReturn['created'] = 'toApiJson' in this.created ? this.created.toApiJson() : this.created;
    }
    if (typeof this.updated !== 'undefined' && this.updated !== null) {
      toReturn['updated'] = 'toApiJson' in this.updated ? this.updated.toApiJson() : this.updated;
    }
    if (typeof this.deleted !== 'undefined' && this.deleted !== null) {
      toReturn['deleted'] = 'toApiJson' in this.deleted ? this.deleted.toApiJson() : this.deleted;
    }
    if (typeof this.origin !== 'undefined') {
      toReturn['origin'] = this.origin;
    }
    if (typeof this.originalId !== 'undefined') {
      toReturn['originalId'] = this.originalId;
    }
    if (typeof this.syncedAppIds !== 'undefined') {
      toReturn['syncedAppIds'] = this.syncedAppIds;
    }
    if (typeof this.permissionToContact !== 'undefined') {
      toReturn['permissionToContact'] = this.permissionToContact;
    }
    return toReturn;
  }
}
class CreateContactRequest {
  static fromProto(proto) {
    let m = new CreateContactRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.accountGroupId !== 'undefined') {
      toReturn['accountGroupId'] = this.accountGroupId;
    }
    if (typeof this.firstName !== 'undefined') {
      toReturn['firstName'] = this.firstName;
    }
    if (typeof this.lastName !== 'undefined') {
      toReturn['lastName'] = this.lastName;
    }
    if (typeof this.address !== 'undefined') {
      toReturn['address'] = this.address;
    }
    if (typeof this.city !== 'undefined') {
      toReturn['city'] = this.city;
    }
    if (typeof this.state !== 'undefined') {
      toReturn['state'] = this.state;
    }
    if (typeof this.country !== 'undefined') {
      toReturn['country'] = this.country;
    }
    if (typeof this.phone !== 'undefined') {
      toReturn['phone'] = this.phone;
    }
    if (typeof this.email !== 'undefined') {
      toReturn['email'] = this.email;
    }
    if (typeof this.origin !== 'undefined') {
      toReturn['origin'] = this.origin;
    }
    if (typeof this.originalId !== 'undefined') {
      toReturn['originalId'] = this.originalId;
    }
    if (typeof this.syncedAppIds !== 'undefined') {
      toReturn['syncedAppIds'] = this.syncedAppIds;
    }
    if (typeof this.permissionToContact !== 'undefined') {
      toReturn['permissionToContact'] = this.permissionToContact;
    }
    return toReturn;
  }
}
class CreateContactResponse {
  static fromProto(proto) {
    let m = new CreateContactResponse();
    m = Object.assign(m, proto);
    if (proto.contact) {
      m.contact = Contact.fromProto(proto.contact);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.contact !== 'undefined' && this.contact !== null) {
      toReturn['contact'] = 'toApiJson' in this.contact ? this.contact.toApiJson() : this.contact;
    }
    return toReturn;
  }
}
class CreateUserListRequest {
  static fromProto(proto) {
    let m = new CreateUserListRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.listId !== 'undefined') {
      toReturn['listId'] = this.listId;
    }
    if (typeof this.listName !== 'undefined') {
      toReturn['listName'] = this.listName;
    }
    return toReturn;
  }
}
class DeleteContactRequest {
  static fromProto(proto) {
    let m = new DeleteContactRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.contactId !== 'undefined') {
      toReturn['contactId'] = this.contactId;
    }
    if (typeof this.accountGroupId !== 'undefined') {
      toReturn['accountGroupId'] = this.accountGroupId;
    }
    if (typeof this.author !== 'undefined') {
      toReturn['author'] = this.author;
    }
    return toReturn;
  }
}
class DeleteUserFromListRequest {
  static fromProto(proto) {
    let m = new DeleteUserFromListRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.listId !== 'undefined') {
      toReturn['listId'] = this.listId;
    }
    if (typeof this.userId !== 'undefined') {
      toReturn['userId'] = this.userId;
    }
    return toReturn;
  }
}
class Filters {
  static fromProto(proto) {
    let m = new Filters();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.source !== 'undefined') {
      toReturn['source'] = this.source;
    }
    if (typeof this.syncedAppIds !== 'undefined') {
      toReturn['syncedAppIds'] = this.syncedAppIds;
    }
    return toReturn;
  }
}
class GetUserListRequest {
  static fromProto(proto) {
    let m = new GetUserListRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.listId !== 'undefined') {
      toReturn['listId'] = this.listId;
    }
    return toReturn;
  }
}
class GetUserListResponse {
  static fromProto(proto) {
    let m = new GetUserListResponse();
    m = Object.assign(m, proto);
    if (proto.userList) {
      m.userList = UserListItem.fromProto(proto.userList);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.userList !== 'undefined' && this.userList !== null) {
      toReturn['userList'] = 'toApiJson' in this.userList ? this.userList.toApiJson() : this.userList;
    }
    return toReturn;
  }
}
class HeaderMapping {
  static fromProto(proto) {
    let m = new HeaderMapping();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.emails !== 'undefined') {
      toReturn['emails'] = this.emails;
    }
    if (typeof this.phones !== 'undefined') {
      toReturn['phones'] = this.phones;
    }
    if (typeof this.firstName !== 'undefined') {
      toReturn['firstName'] = this.firstName;
    }
    if (typeof this.lastName !== 'undefined') {
      toReturn['lastName'] = this.lastName;
    }
    if (typeof this.address !== 'undefined') {
      toReturn['address'] = this.address;
    }
    if (typeof this.city !== 'undefined') {
      toReturn['city'] = this.city;
    }
    if (typeof this.state !== 'undefined') {
      toReturn['state'] = this.state;
    }
    if (typeof this.country !== 'undefined') {
      toReturn['country'] = this.country;
    }
    return toReturn;
  }
}
class ListContactsRequest {
  static fromProto(proto) {
    let m = new ListContactsRequest();
    m = Object.assign(m, proto);
    if (proto.pageSize) {
      m.pageSize = parseInt(proto.pageSize, 10);
    }
    if (proto.sortOptions) {
      m.sortOptions = SortOptions.fromProto(proto.sortOptions);
    }
    if (proto.filters) {
      m.filters = Filters.fromProto(proto.filters);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.accountGroupId !== 'undefined') {
      toReturn['accountGroupId'] = this.accountGroupId;
    }
    if (typeof this.cursor !== 'undefined') {
      toReturn['cursor'] = this.cursor;
    }
    if (typeof this.pageSize !== 'undefined') {
      toReturn['pageSize'] = this.pageSize;
    }
    if (typeof this.searchTerm !== 'undefined') {
      toReturn['searchTerm'] = this.searchTerm;
    }
    if (typeof this.sortOptions !== 'undefined' && this.sortOptions !== null) {
      toReturn['sortOptions'] = 'toApiJson' in this.sortOptions ? this.sortOptions.toApiJson() : this.sortOptions;
    }
    if (typeof this.filters !== 'undefined' && this.filters !== null) {
      toReturn['filters'] = 'toApiJson' in this.filters ? this.filters.toApiJson() : this.filters;
    }
    if (typeof this.appId !== 'undefined') {
      toReturn['appId'] = this.appId;
    }
    return toReturn;
  }
}
class ListContactsResponse {
  static fromProto(proto) {
    let m = new ListContactsResponse();
    m = Object.assign(m, proto);
    if (proto.contacts) {
      m.contacts = proto.contacts.map(Contact.fromProto);
    }
    if (proto.totalResults) {
      m.totalResults = parseInt(proto.totalResults, 10);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.contacts !== 'undefined' && this.contacts !== null) {
      toReturn['contacts'] = 'toApiJson' in this.contacts ? this.contacts.toApiJson() : this.contacts;
    }
    if (typeof this.nextCursor !== 'undefined') {
      toReturn['nextCursor'] = this.nextCursor;
    }
    if (typeof this.hasMore !== 'undefined') {
      toReturn['hasMore'] = this.hasMore;
    }
    if (typeof this.totalResults !== 'undefined') {
      toReturn['totalResults'] = this.totalResults;
    }
    return toReturn;
  }
}
class ListOriginsRequest {
  static fromProto(proto) {
    let m = new ListOriginsRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.accountGroupId !== 'undefined') {
      toReturn['accountGroupId'] = this.accountGroupId;
    }
    return toReturn;
  }
}
class ListOriginsResponse {
  static fromProto(proto) {
    let m = new ListOriginsResponse();
    m = Object.assign(m, proto);
    if (proto.whiteLabeledOrigins) {
      m.whiteLabeledOrigins = proto.whiteLabeledOrigins.map(WhiteLabeledOrigin.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.whiteLabeledOrigins !== 'undefined' && this.whiteLabeledOrigins !== null) {
      toReturn['whiteLabeledOrigins'] = 'toApiJson' in this.whiteLabeledOrigins ? this.whiteLabeledOrigins.toApiJson() : this.whiteLabeledOrigins;
    }
    return toReturn;
  }
}
class ListUserListsRequest {
  static fromProto(proto) {
    let m = new ListUserListsRequest();
    m = Object.assign(m, proto);
    if (proto.pagingOptions) {
      m.pagingOptions = PagedRequestOptions.fromProto(proto.pagingOptions);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.pagingOptions !== 'undefined' && this.pagingOptions !== null) {
      toReturn['pagingOptions'] = 'toApiJson' in this.pagingOptions ? this.pagingOptions.toApiJson() : this.pagingOptions;
    }
    return toReturn;
  }
}
class ListUserListsResponse {
  static fromProto(proto) {
    let m = new ListUserListsResponse();
    m = Object.assign(m, proto);
    if (proto.userLists) {
      m.userLists = proto.userLists.map(UserListItem.fromProto);
    }
    if (proto.pagingMetadata) {
      m.pagingMetadata = PagedResponseMetadata.fromProto(proto.pagingMetadata);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.userLists !== 'undefined' && this.userLists !== null) {
      toReturn['userLists'] = 'toApiJson' in this.userLists ? this.userLists.toApiJson() : this.userLists;
    }
    if (typeof this.pagingMetadata !== 'undefined' && this.pagingMetadata !== null) {
      toReturn['pagingMetadata'] = 'toApiJson' in this.pagingMetadata ? this.pagingMetadata.toApiJson() : this.pagingMetadata;
    }
    return toReturn;
  }
}
class ListUsersFromListRequest {
  static fromProto(proto) {
    let m = new ListUsersFromListRequest();
    m = Object.assign(m, proto);
    if (proto.pagingOptions) {
      m.pagingOptions = PagedRequestOptions.fromProto(proto.pagingOptions);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.listId !== 'undefined') {
      toReturn['listId'] = this.listId;
    }
    if (typeof this.pagingOptions !== 'undefined' && this.pagingOptions !== null) {
      toReturn['pagingOptions'] = 'toApiJson' in this.pagingOptions ? this.pagingOptions.toApiJson() : this.pagingOptions;
    }
    return toReturn;
  }
}
class ListUsersFromListResponse {
  static fromProto(proto) {
    let m = new ListUsersFromListResponse();
    m = Object.assign(m, proto);
    if (proto.pagingMetadata) {
      m.pagingMetadata = PagedResponseMetadata.fromProto(proto.pagingMetadata);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.userIds !== 'undefined') {
      toReturn['userIds'] = this.userIds;
    }
    if (typeof this.pagingMetadata !== 'undefined' && this.pagingMetadata !== null) {
      toReturn['pagingMetadata'] = 'toApiJson' in this.pagingMetadata ? this.pagingMetadata.toApiJson() : this.pagingMetadata;
    }
    return toReturn;
  }
}
class PagedRequestOptions {
  static fromProto(proto) {
    let m = new PagedRequestOptions();
    m = Object.assign(m, proto);
    if (proto.pageSize) {
      m.pageSize = parseInt(proto.pageSize, 10);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.cursor !== 'undefined') {
      toReturn['cursor'] = this.cursor;
    }
    if (typeof this.pageSize !== 'undefined') {
      toReturn['pageSize'] = this.pageSize;
    }
    return toReturn;
  }
}
class PagedResponseMetadata {
  static fromProto(proto) {
    let m = new PagedResponseMetadata();
    m = Object.assign(m, proto);
    if (proto.totalResults) {
      m.totalResults = parseInt(proto.totalResults, 10);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.nextCursor !== 'undefined') {
      toReturn['nextCursor'] = this.nextCursor;
    }
    if (typeof this.hasMore !== 'undefined') {
      toReturn['hasMore'] = this.hasMore;
    }
    if (typeof this.totalResults !== 'undefined') {
      toReturn['totalResults'] = this.totalResults;
    }
    return toReturn;
  }
}
class SortOptions {
  static fromProto(proto) {
    let m = new SortOptions();
    m = Object.assign(m, proto);
    if (proto.direction) {
      m.direction = enumStringToValue$3(SortDirection, proto.direction);
    }
    if (proto.field) {
      m.field = enumStringToValue$3(SortField, proto.field);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.direction !== 'undefined') {
      toReturn['direction'] = this.direction;
    }
    if (typeof this.field !== 'undefined') {
      toReturn['field'] = this.field;
    }
    return toReturn;
  }
}
class TriggerSyncRequest {
  static fromProto(proto) {
    let m = new TriggerSyncRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.accountGroupId !== 'undefined') {
      toReturn['accountGroupId'] = this.accountGroupId;
    }
    if (typeof this.appId !== 'undefined') {
      toReturn['appId'] = this.appId;
    }
    return toReturn;
  }
}
class UpdateContactRequest {
  static fromProto(proto) {
    let m = new UpdateContactRequest();
    m = Object.assign(m, proto);
    if (proto.fieldMask) {
      m.fieldMask = FieldMask.fromProto(proto.fieldMask);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.accountGroupId !== 'undefined') {
      toReturn['accountGroupId'] = this.accountGroupId;
    }
    if (typeof this.firstName !== 'undefined') {
      toReturn['firstName'] = this.firstName;
    }
    if (typeof this.lastName !== 'undefined') {
      toReturn['lastName'] = this.lastName;
    }
    if (typeof this.address !== 'undefined') {
      toReturn['address'] = this.address;
    }
    if (typeof this.city !== 'undefined') {
      toReturn['city'] = this.city;
    }
    if (typeof this.state !== 'undefined') {
      toReturn['state'] = this.state;
    }
    if (typeof this.country !== 'undefined') {
      toReturn['country'] = this.country;
    }
    if (typeof this.phone !== 'undefined') {
      toReturn['phone'] = this.phone;
    }
    if (typeof this.email !== 'undefined') {
      toReturn['email'] = this.email;
    }
    if (typeof this.contactId !== 'undefined') {
      toReturn['contactId'] = this.contactId;
    }
    if (typeof this.author !== 'undefined') {
      toReturn['author'] = this.author;
    }
    if (typeof this.syncedAppIds !== 'undefined') {
      toReturn['syncedAppIds'] = this.syncedAppIds;
    }
    if (typeof this.permissionToContact !== 'undefined') {
      toReturn['permissionToContact'] = this.permissionToContact;
    }
    if (typeof this.fieldMask !== 'undefined' && this.fieldMask !== null) {
      toReturn['fieldMask'] = 'toApiJson' in this.fieldMask ? this.fieldMask.toApiJson() : this.fieldMask;
    }
    return toReturn;
  }
}
class UpdateContactResponse {
  static fromProto(proto) {
    let m = new UpdateContactResponse();
    m = Object.assign(m, proto);
    if (proto.contact) {
      m.contact = Contact.fromProto(proto.contact);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.contact !== 'undefined' && this.contact !== null) {
      toReturn['contact'] = 'toApiJson' in this.contact ? this.contact.toApiJson() : this.contact;
    }
    return toReturn;
  }
}
class UserListItem {
  static fromProto(proto) {
    let m = new UserListItem();
    m = Object.assign(m, proto);
    if (proto.updated) {
      m.updated = new Date(proto.updated);
    }
    if (proto.itemCount) {
      m.itemCount = parseInt(proto.itemCount, 10);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.listId !== 'undefined') {
      toReturn['listId'] = this.listId;
    }
    if (typeof this.listName !== 'undefined') {
      toReturn['listName'] = this.listName;
    }
    if (typeof this.updated !== 'undefined' && this.updated !== null) {
      toReturn['updated'] = 'toApiJson' in this.updated ? this.updated.toApiJson() : this.updated;
    }
    if (typeof this.itemCount !== 'undefined') {
      toReturn['itemCount'] = this.itemCount;
    }
    return toReturn;
  }
}
class WhiteLabeledOrigin {
  static fromProto(proto) {
    let m = new WhiteLabeledOrigin();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.origin !== 'undefined') {
      toReturn['origin'] = this.origin;
    }
    if (typeof this.whiteLabeledName !== 'undefined') {
      toReturn['whiteLabeledName'] = this.whiteLabeledName;
    }
    return toReturn;
  }
}
function enumStringToValue$2(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class ContactMessageRequest {
  static fromProto(proto) {
    let m = new ContactMessageRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.accountGroupId !== 'undefined') {
      toReturn['accountGroupId'] = this.accountGroupId;
    }
    if (typeof this.contactIds !== 'undefined') {
      toReturn['contactIds'] = this.contactIds;
    }
    if (typeof this.subject !== 'undefined') {
      toReturn['subject'] = this.subject;
    }
    if (typeof this.template !== 'undefined') {
      toReturn['template'] = this.template;
    }
    if (typeof this.ccAddress !== 'undefined') {
      toReturn['ccAddress'] = this.ccAddress;
    }
    if (typeof this.bccAddress !== 'undefined') {
      toReturn['bccAddress'] = this.bccAddress;
    }
    if (typeof this.replyAddress !== 'undefined') {
      toReturn['replyAddress'] = this.replyAddress;
    }
    return toReturn;
  }
}
class ContactMessageResponse {
  static fromProto(proto) {
    let m = new ContactMessageResponse();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.responseMessage !== 'undefined') {
      toReturn['responseMessage'] = this.responseMessage;
    }
    return toReturn;
  }
}
function enumStringToValue$1(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class BulkCreateCustomerRequest {
  static fromProto(proto) {
    let m = new BulkCreateCustomerRequest();
    m = Object.assign(m, proto);
    if (proto.mapping) {
      m.mapping = CustomerHeaderMapping.fromProto(proto.mapping);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.accountGroupId !== 'undefined') {
      toReturn['accountGroupId'] = this.accountGroupId;
    }
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.filePath !== 'undefined') {
      toReturn['filePath'] = this.filePath;
    }
    if (typeof this.mapping !== 'undefined' && this.mapping !== null) {
      toReturn['mapping'] = 'toApiJson' in this.mapping ? this.mapping.toApiJson() : this.mapping;
    }
    return toReturn;
  }
}
class BulkCreateCustomerResponse {
  static fromProto(proto) {
    let m = new BulkCreateCustomerResponse();
    m = Object.assign(m, proto);
    if (proto.errors) {
      m.errors = proto.errors.map(BulkCreateCustomerValidationError.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.errors !== 'undefined' && this.errors !== null) {
      toReturn['errors'] = 'toApiJson' in this.errors ? this.errors.toApiJson() : this.errors;
    }
    return toReturn;
  }
}
class BulkCreateCustomerValidationError {
  static fromProto(proto) {
    let m = new BulkCreateCustomerValidationError();
    m = Object.assign(m, proto);
    if (proto.index) {
      m.index = parseInt(proto.index, 10);
    }
    if (proto.errors) {
      m.errors = proto.errors.map(v => enumStringToValue$1(CustomerValidationError, v));
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.index !== 'undefined') {
      toReturn['index'] = this.index;
    }
    if (typeof this.errors !== 'undefined') {
      toReturn['errors'] = this.errors;
    }
    return toReturn;
  }
}
class BulkUpdateCustomersRequest {
  static fromProto(proto) {
    let m = new BulkUpdateCustomersRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.accountGroupId !== 'undefined') {
      toReturn['accountGroupId'] = this.accountGroupId;
    }
    if (typeof this.customerIds !== 'undefined') {
      toReturn['customerIds'] = this.customerIds;
    }
    if (typeof this.permissionToContact !== 'undefined') {
      toReturn['permissionToContact'] = this.permissionToContact;
    }
    return toReturn;
  }
}
class BulkUpdateCustomersResponse {
  static fromProto(proto) {
    let m = new BulkUpdateCustomersResponse();
    m = Object.assign(m, proto);
    if (proto.customers) {
      m.customers = proto.customers.map(Customer.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.customers !== 'undefined' && this.customers !== null) {
      toReturn['customers'] = 'toApiJson' in this.customers ? this.customers.toApiJson() : this.customers;
    }
    return toReturn;
  }
}
class Conflict {
  static fromProto(proto) {
    let m = new Conflict();
    m = Object.assign(m, proto);
    if (proto.permissionToContact) {
      m.permissionToContact = new Date(proto.permissionToContact);
    }
    if (proto.created) {
      m.created = new Date(proto.created);
    }
    if (proto.updated) {
      m.updated = new Date(proto.updated);
    }
    if (proto.deleted) {
      m.deleted = new Date(proto.deleted);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.conflictId !== 'undefined') {
      toReturn['conflictId'] = this.conflictId;
    }
    if (typeof this.customerId !== 'undefined') {
      toReturn['customerId'] = this.customerId;
    }
    if (typeof this.accountGroupId !== 'undefined') {
      toReturn['accountGroupId'] = this.accountGroupId;
    }
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.firstName !== 'undefined') {
      toReturn['firstName'] = this.firstName;
    }
    if (typeof this.lastName !== 'undefined') {
      toReturn['lastName'] = this.lastName;
    }
    if (typeof this.address !== 'undefined') {
      toReturn['address'] = this.address;
    }
    if (typeof this.city !== 'undefined') {
      toReturn['city'] = this.city;
    }
    if (typeof this.state !== 'undefined') {
      toReturn['state'] = this.state;
    }
    if (typeof this.country !== 'undefined') {
      toReturn['country'] = this.country;
    }
    if (typeof this.phoneNumbers !== 'undefined') {
      toReturn['phoneNumbers'] = this.phoneNumbers;
    }
    if (typeof this.emailAddresses !== 'undefined') {
      toReturn['emailAddresses'] = this.emailAddresses;
    }
    if (typeof this.tags !== 'undefined') {
      toReturn['tags'] = this.tags;
    }
    if (typeof this.origins !== 'undefined') {
      toReturn['origins'] = this.origins;
    }
    if (typeof this.permissionToContact !== 'undefined' && this.permissionToContact !== null) {
      toReturn['permissionToContact'] = 'toApiJson' in this.permissionToContact ? this.permissionToContact.toApiJson() : this.permissionToContact;
    }
    if (typeof this.created !== 'undefined' && this.created !== null) {
      toReturn['created'] = 'toApiJson' in this.created ? this.created.toApiJson() : this.created;
    }
    if (typeof this.updated !== 'undefined' && this.updated !== null) {
      toReturn['updated'] = 'toApiJson' in this.updated ? this.updated.toApiJson() : this.updated;
    }
    if (typeof this.deleted !== 'undefined' && this.deleted !== null) {
      toReturn['deleted'] = 'toApiJson' in this.deleted ? this.deleted.toApiJson() : this.deleted;
    }
    if (typeof this.assignedRepFirstName !== 'undefined') {
      toReturn['assignedRepFirstName'] = this.assignedRepFirstName;
    }
    if (typeof this.assignedRepLastName !== 'undefined') {
      toReturn['assignedRepLastName'] = this.assignedRepLastName;
    }
    return toReturn;
  }
}
class ConflictingField {
  static fromProto(proto) {
    let m = new ConflictingField();
    m = Object.assign(m, proto);
    if (proto.fieldType) {
      m.fieldType = enumStringToValue$1(CustomerFieldType, proto.fieldType);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.customerId !== 'undefined') {
      toReturn['customerId'] = this.customerId;
    }
    if (typeof this.fieldType !== 'undefined') {
      toReturn['fieldType'] = this.fieldType;
    }
    if (typeof this.fieldValue !== 'undefined') {
      toReturn['fieldValue'] = this.fieldValue;
    }
    return toReturn;
  }
}
class CreateCustomerRequest {
  static fromProto(proto) {
    let m = new CreateCustomerRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.accountGroupId !== 'undefined') {
      toReturn['accountGroupId'] = this.accountGroupId;
    }
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.firstName !== 'undefined') {
      toReturn['firstName'] = this.firstName;
    }
    if (typeof this.lastName !== 'undefined') {
      toReturn['lastName'] = this.lastName;
    }
    if (typeof this.address !== 'undefined') {
      toReturn['address'] = this.address;
    }
    if (typeof this.city !== 'undefined') {
      toReturn['city'] = this.city;
    }
    if (typeof this.state !== 'undefined') {
      toReturn['state'] = this.state;
    }
    if (typeof this.country !== 'undefined') {
      toReturn['country'] = this.country;
    }
    if (typeof this.phoneNumbers !== 'undefined') {
      toReturn['phoneNumbers'] = this.phoneNumbers;
    }
    if (typeof this.emailAddresses !== 'undefined') {
      toReturn['emailAddresses'] = this.emailAddresses;
    }
    if (typeof this.tags !== 'undefined') {
      toReturn['tags'] = this.tags;
    }
    if (typeof this.origins !== 'undefined') {
      toReturn['origins'] = this.origins;
    }
    if (typeof this.permissionToContact !== 'undefined') {
      toReturn['permissionToContact'] = this.permissionToContact;
    }
    if (typeof this.assignedRepFirstName !== 'undefined') {
      toReturn['assignedRepFirstName'] = this.assignedRepFirstName;
    }
    if (typeof this.assignedRepLastName !== 'undefined') {
      toReturn['assignedRepLastName'] = this.assignedRepLastName;
    }
    return toReturn;
  }
}
class CreateCustomerResponse {
  static fromProto(proto) {
    let m = new CreateCustomerResponse();
    m = Object.assign(m, proto);
    if (proto.customer) {
      m.customer = Customer.fromProto(proto.customer);
    }
    if (proto.conflict) {
      m.conflict = Conflict.fromProto(proto.conflict);
    }
    if (proto.entityType) {
      m.entityType = enumStringToValue$1(EntityType, proto.entityType);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.customer !== 'undefined' && this.customer !== null) {
      toReturn['customer'] = 'toApiJson' in this.customer ? this.customer.toApiJson() : this.customer;
    }
    if (typeof this.conflict !== 'undefined' && this.conflict !== null) {
      toReturn['conflict'] = 'toApiJson' in this.conflict ? this.conflict.toApiJson() : this.conflict;
    }
    if (typeof this.entityType !== 'undefined') {
      toReturn['entityType'] = this.entityType;
    }
    return toReturn;
  }
}
class CreateWithoutConflictRequest {
  static fromProto(proto) {
    let m = new CreateWithoutConflictRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.accountGroupId !== 'undefined') {
      toReturn['accountGroupId'] = this.accountGroupId;
    }
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.firstName !== 'undefined') {
      toReturn['firstName'] = this.firstName;
    }
    if (typeof this.lastName !== 'undefined') {
      toReturn['lastName'] = this.lastName;
    }
    if (typeof this.address !== 'undefined') {
      toReturn['address'] = this.address;
    }
    if (typeof this.city !== 'undefined') {
      toReturn['city'] = this.city;
    }
    if (typeof this.state !== 'undefined') {
      toReturn['state'] = this.state;
    }
    if (typeof this.country !== 'undefined') {
      toReturn['country'] = this.country;
    }
    if (typeof this.phoneNumbers !== 'undefined') {
      toReturn['phoneNumbers'] = this.phoneNumbers;
    }
    if (typeof this.emailAddresses !== 'undefined') {
      toReturn['emailAddresses'] = this.emailAddresses;
    }
    if (typeof this.tags !== 'undefined') {
      toReturn['tags'] = this.tags;
    }
    if (typeof this.origins !== 'undefined') {
      toReturn['origins'] = this.origins;
    }
    if (typeof this.permissionToContact !== 'undefined') {
      toReturn['permissionToContact'] = this.permissionToContact;
    }
    if (typeof this.assignedRepFirstName !== 'undefined') {
      toReturn['assignedRepFirstName'] = this.assignedRepFirstName;
    }
    if (typeof this.assignedRepLastName !== 'undefined') {
      toReturn['assignedRepLastName'] = this.assignedRepLastName;
    }
    return toReturn;
  }
}
class CreateWithoutConflictResponse {
  static fromProto(proto) {
    let m = new CreateWithoutConflictResponse();
    m = Object.assign(m, proto);
    if (proto.customer) {
      m.customer = Customer.fromProto(proto.customer);
    }
    if (proto.conflictingFields) {
      m.conflictingFields = proto.conflictingFields.map(ConflictingField.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.customer !== 'undefined' && this.customer !== null) {
      toReturn['customer'] = 'toApiJson' in this.customer ? this.customer.toApiJson() : this.customer;
    }
    if (typeof this.conflictingFields !== 'undefined' && this.conflictingFields !== null) {
      toReturn['conflictingFields'] = 'toApiJson' in this.conflictingFields ? this.conflictingFields.toApiJson() : this.conflictingFields;
    }
    return toReturn;
  }
}
class Customer {
  static fromProto(proto) {
    let m = new Customer();
    m = Object.assign(m, proto);
    if (proto.permissionToContact) {
      m.permissionToContact = new Date(proto.permissionToContact);
    }
    if (proto.created) {
      m.created = new Date(proto.created);
    }
    if (proto.updated) {
      m.updated = new Date(proto.updated);
    }
    if (proto.deleted) {
      m.deleted = new Date(proto.deleted);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.customerId !== 'undefined') {
      toReturn['customerId'] = this.customerId;
    }
    if (typeof this.accountGroupId !== 'undefined') {
      toReturn['accountGroupId'] = this.accountGroupId;
    }
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.firstName !== 'undefined') {
      toReturn['firstName'] = this.firstName;
    }
    if (typeof this.lastName !== 'undefined') {
      toReturn['lastName'] = this.lastName;
    }
    if (typeof this.address !== 'undefined') {
      toReturn['address'] = this.address;
    }
    if (typeof this.city !== 'undefined') {
      toReturn['city'] = this.city;
    }
    if (typeof this.state !== 'undefined') {
      toReturn['state'] = this.state;
    }
    if (typeof this.country !== 'undefined') {
      toReturn['country'] = this.country;
    }
    if (typeof this.phoneNumbers !== 'undefined') {
      toReturn['phoneNumbers'] = this.phoneNumbers;
    }
    if (typeof this.emailAddresses !== 'undefined') {
      toReturn['emailAddresses'] = this.emailAddresses;
    }
    if (typeof this.tags !== 'undefined') {
      toReturn['tags'] = this.tags;
    }
    if (typeof this.origins !== 'undefined') {
      toReturn['origins'] = this.origins;
    }
    if (typeof this.permissionToContact !== 'undefined' && this.permissionToContact !== null) {
      toReturn['permissionToContact'] = 'toApiJson' in this.permissionToContact ? this.permissionToContact.toApiJson() : this.permissionToContact;
    }
    if (typeof this.created !== 'undefined' && this.created !== null) {
      toReturn['created'] = 'toApiJson' in this.created ? this.created.toApiJson() : this.created;
    }
    if (typeof this.updated !== 'undefined' && this.updated !== null) {
      toReturn['updated'] = 'toApiJson' in this.updated ? this.updated.toApiJson() : this.updated;
    }
    if (typeof this.deleted !== 'undefined' && this.deleted !== null) {
      toReturn['deleted'] = 'toApiJson' in this.deleted ? this.deleted.toApiJson() : this.deleted;
    }
    if (typeof this.vendorCustomerId !== 'undefined') {
      toReturn['vendorCustomerId'] = this.vendorCustomerId;
    }
    if (typeof this.assignedRepFirstName !== 'undefined') {
      toReturn['assignedRepFirstName'] = this.assignedRepFirstName;
    }
    if (typeof this.assignedRepLastName !== 'undefined') {
      toReturn['assignedRepLastName'] = this.assignedRepLastName;
    }
    return toReturn;
  }
}
class CustomerFilters {
  static fromProto(proto) {
    let m = new CustomerFilters();
    m = Object.assign(m, proto);
    if (proto.created) {
      m.created = DateRangeFilter.fromProto(proto.created);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.created !== 'undefined' && this.created !== null) {
      toReturn['created'] = 'toApiJson' in this.created ? this.created.toApiJson() : this.created;
    }
    if (typeof this.tag !== 'undefined') {
      toReturn['tag'] = this.tag;
    }
    if (typeof this.origin !== 'undefined') {
      toReturn['origin'] = this.origin;
    }
    if (typeof this.negateTags !== 'undefined') {
      toReturn['negateTags'] = this.negateTags;
    }
    return toReturn;
  }
}
class CustomerHeaderMapping {
  static fromProto(proto) {
    let m = new CustomerHeaderMapping();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.emails !== 'undefined') {
      toReturn['emails'] = this.emails;
    }
    if (typeof this.phones !== 'undefined') {
      toReturn['phones'] = this.phones;
    }
    if (typeof this.firstName !== 'undefined') {
      toReturn['firstName'] = this.firstName;
    }
    if (typeof this.lastName !== 'undefined') {
      toReturn['lastName'] = this.lastName;
    }
    if (typeof this.address !== 'undefined') {
      toReturn['address'] = this.address;
    }
    if (typeof this.city !== 'undefined') {
      toReturn['city'] = this.city;
    }
    if (typeof this.state !== 'undefined') {
      toReturn['state'] = this.state;
    }
    if (typeof this.country !== 'undefined') {
      toReturn['country'] = this.country;
    }
    if (typeof this.permissionToContact !== 'undefined') {
      toReturn['permissionToContact'] = this.permissionToContact;
    }
    return toReturn;
  }
}
class GetMultiCustomersRequestCustomerIdentifiers {
  static fromProto(proto) {
    let m = new GetMultiCustomersRequestCustomerIdentifiers();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.accountGroupId !== 'undefined') {
      toReturn['accountGroupId'] = this.accountGroupId;
    }
    if (typeof this.customerId !== 'undefined') {
      toReturn['customerId'] = this.customerId;
    }
    return toReturn;
  }
}
class CustomerOrigin {
  static fromProto(proto) {
    let m = new CustomerOrigin();
    m = Object.assign(m, proto);
    if (proto.count) {
      m.count = parseInt(proto.count, 10);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.origin !== 'undefined') {
      toReturn['origin'] = this.origin;
    }
    if (typeof this.name !== 'undefined') {
      toReturn['name'] = this.name;
    }
    if (typeof this.count !== 'undefined') {
      toReturn['count'] = this.count;
    }
    return toReturn;
  }
}
class CustomerSortOptions {
  static fromProto(proto) {
    let m = new CustomerSortOptions();
    m = Object.assign(m, proto);
    if (proto.direction) {
      m.direction = enumStringToValue$1(CustomerSortDirection, proto.direction);
    }
    if (proto.field) {
      m.field = enumStringToValue$1(CustomerSortField, proto.field);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.direction !== 'undefined') {
      toReturn['direction'] = this.direction;
    }
    if (typeof this.field !== 'undefined') {
      toReturn['field'] = this.field;
    }
    return toReturn;
  }
}
class DateRangeFilter {
  static fromProto(proto) {
    let m = new DateRangeFilter();
    m = Object.assign(m, proto);
    if (proto.beginRange) {
      m.beginRange = new Date(proto.beginRange);
    }
    if (proto.endRange) {
      m.endRange = new Date(proto.endRange);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.beginRange !== 'undefined' && this.beginRange !== null) {
      toReturn['beginRange'] = 'toApiJson' in this.beginRange ? this.beginRange.toApiJson() : this.beginRange;
    }
    if (typeof this.endRange !== 'undefined' && this.endRange !== null) {
      toReturn['endRange'] = 'toApiJson' in this.endRange ? this.endRange.toApiJson() : this.endRange;
    }
    return toReturn;
  }
}
class DeleteCustomerRequest {
  static fromProto(proto) {
    let m = new DeleteCustomerRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.customerId !== 'undefined') {
      toReturn['customerId'] = this.customerId;
    }
    if (typeof this.accountGroupId !== 'undefined') {
      toReturn['accountGroupId'] = this.accountGroupId;
    }
    return toReturn;
  }
}
class DesyncCustomersRequest {
  static fromProto(proto) {
    let m = new DesyncCustomersRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.accountGroupId !== 'undefined') {
      toReturn['accountGroupId'] = this.accountGroupId;
    }
    if (typeof this.customerIds !== 'undefined') {
      toReturn['customerIds'] = this.customerIds;
    }
    if (typeof this.appId !== 'undefined') {
      toReturn['appId'] = this.appId;
    }
    return toReturn;
  }
}
class GetCustomerRequest {
  static fromProto(proto) {
    let m = new GetCustomerRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.accountGroupId !== 'undefined') {
      toReturn['accountGroupId'] = this.accountGroupId;
    }
    if (typeof this.customerId !== 'undefined') {
      toReturn['customerId'] = this.customerId;
    }
    return toReturn;
  }
}
class GetCustomerResponse {
  static fromProto(proto) {
    let m = new GetCustomerResponse();
    m = Object.assign(m, proto);
    if (proto.customer) {
      m.customer = Customer.fromProto(proto.customer);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.customer !== 'undefined' && this.customer !== null) {
      toReturn['customer'] = 'toApiJson' in this.customer ? this.customer.toApiJson() : this.customer;
    }
    return toReturn;
  }
}
class GetMultiCustomersRequest {
  static fromProto(proto) {
    let m = new GetMultiCustomersRequest();
    m = Object.assign(m, proto);
    if (proto.customerIdentifiers) {
      m.customerIdentifiers = proto.customerIdentifiers.map(GetMultiCustomersRequestCustomerIdentifiers.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.customerIdentifiers !== 'undefined' && this.customerIdentifiers !== null) {
      toReturn['customerIdentifiers'] = 'toApiJson' in this.customerIdentifiers ? this.customerIdentifiers.toApiJson() : this.customerIdentifiers;
    }
    return toReturn;
  }
}
class GetMultiCustomersResponse {
  static fromProto(proto) {
    let m = new GetMultiCustomersResponse();
    m = Object.assign(m, proto);
    if (proto.customers) {
      m.customers = proto.customers.map(Customer.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.customers !== 'undefined' && this.customers !== null) {
      toReturn['customers'] = 'toApiJson' in this.customers ? this.customers.toApiJson() : this.customers;
    }
    return toReturn;
  }
}
class ListCustomerOriginsRequest {
  static fromProto(proto) {
    let m = new ListCustomerOriginsRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.accountGroupId !== 'undefined') {
      toReturn['accountGroupId'] = this.accountGroupId;
    }
    return toReturn;
  }
}
class ListCustomerOriginsResponse {
  static fromProto(proto) {
    let m = new ListCustomerOriginsResponse();
    m = Object.assign(m, proto);
    if (proto.origins) {
      m.origins = proto.origins.map(CustomerOrigin.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.origins !== 'undefined' && this.origins !== null) {
      toReturn['origins'] = 'toApiJson' in this.origins ? this.origins.toApiJson() : this.origins;
    }
    return toReturn;
  }
}
class ListCustomersRequest {
  static fromProto(proto) {
    let m = new ListCustomersRequest();
    m = Object.assign(m, proto);
    if (proto.pageSize) {
      m.pageSize = parseInt(proto.pageSize, 10);
    }
    if (proto.sortOptions) {
      m.sortOptions = CustomerSortOptions.fromProto(proto.sortOptions);
    }
    if (proto.filters) {
      m.filters = CustomerFilters.fromProto(proto.filters);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.accountGroupId !== 'undefined') {
      toReturn['accountGroupId'] = this.accountGroupId;
    }
    if (typeof this.cursor !== 'undefined') {
      toReturn['cursor'] = this.cursor;
    }
    if (typeof this.pageSize !== 'undefined') {
      toReturn['pageSize'] = this.pageSize;
    }
    if (typeof this.searchTerm !== 'undefined') {
      toReturn['searchTerm'] = this.searchTerm;
    }
    if (typeof this.sortOptions !== 'undefined' && this.sortOptions !== null) {
      toReturn['sortOptions'] = 'toApiJson' in this.sortOptions ? this.sortOptions.toApiJson() : this.sortOptions;
    }
    if (typeof this.filters !== 'undefined' && this.filters !== null) {
      toReturn['filters'] = 'toApiJson' in this.filters ? this.filters.toApiJson() : this.filters;
    }
    return toReturn;
  }
}
class ListCustomersResponse {
  static fromProto(proto) {
    let m = new ListCustomersResponse();
    m = Object.assign(m, proto);
    if (proto.customers) {
      m.customers = proto.customers.map(Customer.fromProto);
    }
    if (proto.totalResults) {
      m.totalResults = parseInt(proto.totalResults, 10);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.customers !== 'undefined' && this.customers !== null) {
      toReturn['customers'] = 'toApiJson' in this.customers ? this.customers.toApiJson() : this.customers;
    }
    if (typeof this.nextCursor !== 'undefined') {
      toReturn['nextCursor'] = this.nextCursor;
    }
    if (typeof this.hasMore !== 'undefined') {
      toReturn['hasMore'] = this.hasMore;
    }
    if (typeof this.totalResults !== 'undefined') {
      toReturn['totalResults'] = this.totalResults;
    }
    return toReturn;
  }
}
class SyncCustomersRequest {
  static fromProto(proto) {
    let m = new SyncCustomersRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.accountGroupId !== 'undefined') {
      toReturn['accountGroupId'] = this.accountGroupId;
    }
    if (typeof this.customerIds !== 'undefined') {
      toReturn['customerIds'] = this.customerIds;
    }
    if (typeof this.appId !== 'undefined') {
      toReturn['appId'] = this.appId;
    }
    return toReturn;
  }
}
class UpdateCustomerRequest {
  static fromProto(proto) {
    let m = new UpdateCustomerRequest();
    m = Object.assign(m, proto);
    if (proto.fieldMask) {
      m.fieldMask = FieldMask.fromProto(proto.fieldMask);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.accountGroupId !== 'undefined') {
      toReturn['accountGroupId'] = this.accountGroupId;
    }
    if (typeof this.customerId !== 'undefined') {
      toReturn['customerId'] = this.customerId;
    }
    if (typeof this.firstName !== 'undefined') {
      toReturn['firstName'] = this.firstName;
    }
    if (typeof this.lastName !== 'undefined') {
      toReturn['lastName'] = this.lastName;
    }
    if (typeof this.address !== 'undefined') {
      toReturn['address'] = this.address;
    }
    if (typeof this.city !== 'undefined') {
      toReturn['city'] = this.city;
    }
    if (typeof this.state !== 'undefined') {
      toReturn['state'] = this.state;
    }
    if (typeof this.country !== 'undefined') {
      toReturn['country'] = this.country;
    }
    if (typeof this.phoneNumbers !== 'undefined') {
      toReturn['phoneNumbers'] = this.phoneNumbers;
    }
    if (typeof this.emailAddresses !== 'undefined') {
      toReturn['emailAddresses'] = this.emailAddresses;
    }
    if (typeof this.tags !== 'undefined') {
      toReturn['tags'] = this.tags;
    }
    if (typeof this.origin !== 'undefined') {
      toReturn['origin'] = this.origin;
    }
    if (typeof this.permissionToContact !== 'undefined') {
      toReturn['permissionToContact'] = this.permissionToContact;
    }
    if (typeof this.fieldMask !== 'undefined' && this.fieldMask !== null) {
      toReturn['fieldMask'] = 'toApiJson' in this.fieldMask ? this.fieldMask.toApiJson() : this.fieldMask;
    }
    if (typeof this.assignedRepFirstName !== 'undefined') {
      toReturn['assignedRepFirstName'] = this.assignedRepFirstName;
    }
    if (typeof this.assignedRepLastName !== 'undefined') {
      toReturn['assignedRepLastName'] = this.assignedRepLastName;
    }
    return toReturn;
  }
}
class UpdateCustomerResponse {
  static fromProto(proto) {
    let m = new UpdateCustomerResponse();
    m = Object.assign(m, proto);
    if (proto.customer) {
      m.customer = Customer.fromProto(proto.customer);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.customer !== 'undefined' && this.customer !== null) {
      toReturn['customer'] = 'toApiJson' in this.customer ? this.customer.toApiJson() : this.customer;
    }
    return toReturn;
  }
}
class VendorAssociateCustomerIDRequest {
  static fromProto(proto) {
    let m = new VendorAssociateCustomerIDRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.customerId !== 'undefined') {
      toReturn['customerId'] = this.customerId;
    }
    if (typeof this.vendorCustomerId !== 'undefined') {
      toReturn['vendorCustomerId'] = this.vendorCustomerId;
    }
    if (typeof this.vendorAppId !== 'undefined') {
      toReturn['vendorAppId'] = this.vendorAppId;
    }
    return toReturn;
  }
}
class VendorCreateCustomerRequest {
  static fromProto(proto) {
    let m = new VendorCreateCustomerRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.accountGroupId !== 'undefined') {
      toReturn['accountGroupId'] = this.accountGroupId;
    }
    if (typeof this.vendorCustomerId !== 'undefined') {
      toReturn['vendorCustomerId'] = this.vendorCustomerId;
    }
    if (typeof this.appId !== 'undefined') {
      toReturn['appId'] = this.appId;
    }
    if (typeof this.firstName !== 'undefined') {
      toReturn['firstName'] = this.firstName;
    }
    if (typeof this.lastName !== 'undefined') {
      toReturn['lastName'] = this.lastName;
    }
    if (typeof this.address !== 'undefined') {
      toReturn['address'] = this.address;
    }
    if (typeof this.city !== 'undefined') {
      toReturn['city'] = this.city;
    }
    if (typeof this.state !== 'undefined') {
      toReturn['state'] = this.state;
    }
    if (typeof this.country !== 'undefined') {
      toReturn['country'] = this.country;
    }
    if (typeof this.phoneNumbers !== 'undefined') {
      toReturn['phoneNumbers'] = this.phoneNumbers;
    }
    if (typeof this.emailAddresses !== 'undefined') {
      toReturn['emailAddresses'] = this.emailAddresses;
    }
    if (typeof this.tags !== 'undefined') {
      toReturn['tags'] = this.tags;
    }
    if (typeof this.origin !== 'undefined') {
      toReturn['origin'] = this.origin;
    }
    if (typeof this.permissionToContact !== 'undefined') {
      toReturn['permissionToContact'] = this.permissionToContact;
    }
    if (typeof this.assignedRepFirstName !== 'undefined') {
      toReturn['assignedRepFirstName'] = this.assignedRepFirstName;
    }
    if (typeof this.assignedRepLastName !== 'undefined') {
      toReturn['assignedRepLastName'] = this.assignedRepLastName;
    }
    return toReturn;
  }
}
class VendorCreateCustomerResponse {
  static fromProto(proto) {
    let m = new VendorCreateCustomerResponse();
    m = Object.assign(m, proto);
    if (proto.customer) {
      m.customer = Customer.fromProto(proto.customer);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.customer !== 'undefined' && this.customer !== null) {
      toReturn['customer'] = 'toApiJson' in this.customer ? this.customer.toApiJson() : this.customer;
    }
    if (typeof this.conflictingCustomerId !== 'undefined') {
      toReturn['conflictingCustomerId'] = this.conflictingCustomerId;
    }
    return toReturn;
  }
}
class VendorDeleteCustomerRequest {
  static fromProto(proto) {
    let m = new VendorDeleteCustomerRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.vendorCustomerId !== 'undefined') {
      toReturn['vendorCustomerId'] = this.vendorCustomerId;
    }
    if (typeof this.accountGroupId !== 'undefined') {
      toReturn['accountGroupId'] = this.accountGroupId;
    }
    if (typeof this.vendorAppId !== 'undefined') {
      toReturn['vendorAppId'] = this.vendorAppId;
    }
    return toReturn;
  }
}
class VendorGetCustomerRequest {
  static fromProto(proto) {
    let m = new VendorGetCustomerRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.accountGroupId !== 'undefined') {
      toReturn['accountGroupId'] = this.accountGroupId;
    }
    if (typeof this.vendorCustomerId !== 'undefined') {
      toReturn['vendorCustomerId'] = this.vendorCustomerId;
    }
    if (typeof this.vendorAppId !== 'undefined') {
      toReturn['vendorAppId'] = this.vendorAppId;
    }
    return toReturn;
  }
}
class VendorGetCustomerResponse {
  static fromProto(proto) {
    let m = new VendorGetCustomerResponse();
    m = Object.assign(m, proto);
    if (proto.customer) {
      m.customer = Customer.fromProto(proto.customer);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.customer !== 'undefined' && this.customer !== null) {
      toReturn['customer'] = 'toApiJson' in this.customer ? this.customer.toApiJson() : this.customer;
    }
    if (typeof this.conflictingCustomerId !== 'undefined') {
      toReturn['conflictingCustomerId'] = this.conflictingCustomerId;
    }
    return toReturn;
  }
}
class VendorListCustomerOriginsRequest {
  static fromProto(proto) {
    let m = new VendorListCustomerOriginsRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.accountGroupId !== 'undefined') {
      toReturn['accountGroupId'] = this.accountGroupId;
    }
    return toReturn;
  }
}
class VendorListCustomerOriginsResponse {
  static fromProto(proto) {
    let m = new VendorListCustomerOriginsResponse();
    m = Object.assign(m, proto);
    if (proto.origins) {
      m.origins = proto.origins.map(CustomerOrigin.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.origins !== 'undefined' && this.origins !== null) {
      toReturn['origins'] = 'toApiJson' in this.origins ? this.origins.toApiJson() : this.origins;
    }
    return toReturn;
  }
}
class VendorListCustomersRequest {
  static fromProto(proto) {
    let m = new VendorListCustomersRequest();
    m = Object.assign(m, proto);
    if (proto.pageSize) {
      m.pageSize = parseInt(proto.pageSize, 10);
    }
    if (proto.sortOptions) {
      m.sortOptions = CustomerSortOptions.fromProto(proto.sortOptions);
    }
    if (proto.filters) {
      m.filters = CustomerFilters.fromProto(proto.filters);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.accountGroupId !== 'undefined') {
      toReturn['accountGroupId'] = this.accountGroupId;
    }
    if (typeof this.vendorAppId !== 'undefined') {
      toReturn['vendorAppId'] = this.vendorAppId;
    }
    if (typeof this.cursor !== 'undefined') {
      toReturn['cursor'] = this.cursor;
    }
    if (typeof this.pageSize !== 'undefined') {
      toReturn['pageSize'] = this.pageSize;
    }
    if (typeof this.searchTerm !== 'undefined') {
      toReturn['searchTerm'] = this.searchTerm;
    }
    if (typeof this.sortOptions !== 'undefined' && this.sortOptions !== null) {
      toReturn['sortOptions'] = 'toApiJson' in this.sortOptions ? this.sortOptions.toApiJson() : this.sortOptions;
    }
    if (typeof this.filters !== 'undefined' && this.filters !== null) {
      toReturn['filters'] = 'toApiJson' in this.filters ? this.filters.toApiJson() : this.filters;
    }
    return toReturn;
  }
}
class VendorListCustomersResponse {
  static fromProto(proto) {
    let m = new VendorListCustomersResponse();
    m = Object.assign(m, proto);
    if (proto.customers) {
      m.customers = proto.customers.map(Customer.fromProto);
    }
    if (proto.totalResults) {
      m.totalResults = parseInt(proto.totalResults, 10);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.customers !== 'undefined' && this.customers !== null) {
      toReturn['customers'] = 'toApiJson' in this.customers ? this.customers.toApiJson() : this.customers;
    }
    if (typeof this.nextCursor !== 'undefined') {
      toReturn['nextCursor'] = this.nextCursor;
    }
    if (typeof this.hasMore !== 'undefined') {
      toReturn['hasMore'] = this.hasMore;
    }
    if (typeof this.totalResults !== 'undefined') {
      toReturn['totalResults'] = this.totalResults;
    }
    return toReturn;
  }
}
class VendorSyncAllCustomersRequest {
  static fromProto(proto) {
    let m = new VendorSyncAllCustomersRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.accountGroupId !== 'undefined') {
      toReturn['accountGroupId'] = this.accountGroupId;
    }
    if (typeof this.vendorAppId !== 'undefined') {
      toReturn['vendorAppId'] = this.vendorAppId;
    }
    return toReturn;
  }
}
class VendorUpdateCustomerRequest {
  static fromProto(proto) {
    let m = new VendorUpdateCustomerRequest();
    m = Object.assign(m, proto);
    if (proto.fieldMask) {
      m.fieldMask = FieldMask.fromProto(proto.fieldMask);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.accountGroupId !== 'undefined') {
      toReturn['accountGroupId'] = this.accountGroupId;
    }
    if (typeof this.vendorCustomerId !== 'undefined') {
      toReturn['vendorCustomerId'] = this.vendorCustomerId;
    }
    if (typeof this.vendorAppId !== 'undefined') {
      toReturn['vendorAppId'] = this.vendorAppId;
    }
    if (typeof this.firstName !== 'undefined') {
      toReturn['firstName'] = this.firstName;
    }
    if (typeof this.lastName !== 'undefined') {
      toReturn['lastName'] = this.lastName;
    }
    if (typeof this.address !== 'undefined') {
      toReturn['address'] = this.address;
    }
    if (typeof this.city !== 'undefined') {
      toReturn['city'] = this.city;
    }
    if (typeof this.state !== 'undefined') {
      toReturn['state'] = this.state;
    }
    if (typeof this.country !== 'undefined') {
      toReturn['country'] = this.country;
    }
    if (typeof this.phoneNumbers !== 'undefined') {
      toReturn['phoneNumbers'] = this.phoneNumbers;
    }
    if (typeof this.emailAddresses !== 'undefined') {
      toReturn['emailAddresses'] = this.emailAddresses;
    }
    if (typeof this.tags !== 'undefined') {
      toReturn['tags'] = this.tags;
    }
    if (typeof this.origin !== 'undefined') {
      toReturn['origin'] = this.origin;
    }
    if (typeof this.permissionToContact !== 'undefined') {
      toReturn['permissionToContact'] = this.permissionToContact;
    }
    if (typeof this.fieldMask !== 'undefined' && this.fieldMask !== null) {
      toReturn['fieldMask'] = 'toApiJson' in this.fieldMask ? this.fieldMask.toApiJson() : this.fieldMask;
    }
    if (typeof this.assignedRepFirstName !== 'undefined') {
      toReturn['assignedRepFirstName'] = this.assignedRepFirstName;
    }
    if (typeof this.assignedRepLastName !== 'undefined') {
      toReturn['assignedRepLastName'] = this.assignedRepLastName;
    }
    return toReturn;
  }
}
class VendorUpdateCustomerResponse {
  static fromProto(proto) {
    let m = new VendorUpdateCustomerResponse();
    m = Object.assign(m, proto);
    if (proto.customer) {
      m.customer = Customer.fromProto(proto.customer);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.customer !== 'undefined' && this.customer !== null) {
      toReturn['customer'] = 'toApiJson' in this.customer ? this.customer.toApiJson() : this.customer;
    }
    if (typeof this.conflictingCustomerId !== 'undefined') {
      toReturn['conflictingCustomerId'] = this.conflictingCustomerId;
    }
    return toReturn;
  }
}
function enumStringToValue(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class CustomerIdMapping {
  static fromProto(proto) {
    let m = new CustomerIdMapping();
    m = Object.assign(m, proto);
    if (proto.customerType) {
      m.customerType = enumStringToValue(CustomerType, proto.customerType);
    }
    if (proto.created) {
      m.created = new Date(proto.created);
    }
    if (proto.updated) {
      m.updated = new Date(proto.updated);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.customerId !== 'undefined') {
      toReturn['customerId'] = this.customerId;
    }
    if (typeof this.vendorAppId !== 'undefined') {
      toReturn['vendorAppId'] = this.vendorAppId;
    }
    if (typeof this.vendorCustomerId !== 'undefined') {
      toReturn['vendorCustomerId'] = this.vendorCustomerId;
    }
    if (typeof this.customerType !== 'undefined') {
      toReturn['customerType'] = this.customerType;
    }
    if (typeof this.created !== 'undefined' && this.created !== null) {
      toReturn['created'] = 'toApiJson' in this.created ? this.created.toApiJson() : this.created;
    }
    if (typeof this.updated !== 'undefined' && this.updated !== null) {
      toReturn['updated'] = 'toApiJson' in this.updated ? this.updated.toApiJson() : this.updated;
    }
    return toReturn;
  }
}
class GetCustomerIdMappingRequest {
  static fromProto(proto) {
    let m = new GetCustomerIdMappingRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.accountGroupId !== 'undefined') {
      toReturn['accountGroupId'] = this.accountGroupId;
    }
    if (typeof this.customerId !== 'undefined') {
      toReturn['customerId'] = this.customerId;
    }
    if (typeof this.vendorAppId !== 'undefined') {
      toReturn['vendorAppId'] = this.vendorAppId;
    }
    return toReturn;
  }
}
class GetCustomerIdMappingResponse {
  static fromProto(proto) {
    let m = new GetCustomerIdMappingResponse();
    m = Object.assign(m, proto);
    if (proto.customerIdMapping) {
      m.customerIdMapping = CustomerIdMapping.fromProto(proto.customerIdMapping);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.customerIdMapping !== 'undefined' && this.customerIdMapping !== null) {
      toReturn['customerIdMapping'] = 'toApiJson' in this.customerIdMapping ? this.customerIdMapping.toApiJson() : this.customerIdMapping;
    }
    return toReturn;
  }
}
const environment = (window ? window['environment'] : 'prod') ?? 'prod';
const hostMap = {
  'local': 'contacts-api.vendasta-local.com',
  'test': '',
  'demo': 'contacts-api-demo.vendasta-internal.com',
  'prod': 'contacts-api-prod.vendasta-internal.com',
  'production': 'contacts-api-prod.vendasta-internal.com'
};
let HostService = /*#__PURE__*/(() => {
  class HostService {
    get host() {
      return hostMap[environment.toLowerCase()];
    }
    get hostWithScheme() {
      return 'https://' + this.host;
    }
  }
  HostService.ɵfac = function HostService_Factory(t) {
    return new (t || HostService)();
  };
  HostService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: HostService,
    factory: HostService.ɵfac,
    providedIn: 'root'
  });
  return HostService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// API Service.
// *********************************
let ContactEmailApiService = /*#__PURE__*/(() => {
  class ContactEmailApiService {
    constructor(http, hostService) {
      this.http = http;
      this.hostService = hostService;
      this._host = this.hostService.hostWithScheme;
    }
    apiOptions() {
      return {
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        }),
        withCredentials: true
      };
    }
    createContactMessage(r) {
      const request = r.toApiJson ? r : new ContactMessageRequest(r);
      return this.http.post(this._host + "/contacts.v1.ContactEmailService/CreateContactMessage", request.toApiJson(), this.apiOptions()).pipe(map(resp => ContactMessageResponse.fromProto(resp)));
    }
  }
  ContactEmailApiService.ɵfac = function ContactEmailApiService_Factory(t) {
    return new (t || ContactEmailApiService)(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(HostService));
  };
  ContactEmailApiService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: ContactEmailApiService,
    factory: ContactEmailApiService.ɵfac,
    providedIn: 'root'
  });
  return ContactEmailApiService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// API Service.
// *********************************
let ContactsApiService = /*#__PURE__*/(() => {
  class ContactsApiService {
    constructor(http, hostService) {
      this.http = http;
      this.hostService = hostService;
      this._host = this.hostService.hostWithScheme;
    }
    apiOptions() {
      return {
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        }),
        withCredentials: true
      };
    }
    create(r) {
      const request = r.toApiJson ? r : new CreateContactRequest(r);
      return this.http.post(this._host + "/contacts.v1.Contacts/Create", request.toApiJson(), this.apiOptions()).pipe(map(resp => CreateContactResponse.fromProto(resp)));
    }
    delete(r) {
      const request = r.toApiJson ? r : new DeleteContactRequest(r);
      return this.http.post(this._host + "/contacts.v1.Contacts/Delete", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    update(r) {
      const request = r.toApiJson ? r : new UpdateContactRequest(r);
      return this.http.post(this._host + "/contacts.v1.Contacts/Update", request.toApiJson(), this.apiOptions()).pipe(map(resp => UpdateContactResponse.fromProto(resp)));
    }
    list(r) {
      const request = r.toApiJson ? r : new ListContactsRequest(r);
      return this.http.post(this._host + "/contacts.v1.Contacts/List", request.toApiJson(), this.apiOptions()).pipe(map(resp => ListContactsResponse.fromProto(resp)));
    }
    listOrigins(r) {
      const request = r.toApiJson ? r : new ListOriginsRequest(r);
      return this.http.post(this._host + "/contacts.v1.Contacts/ListOrigins", request.toApiJson(), this.apiOptions()).pipe(map(resp => ListOriginsResponse.fromProto(resp)));
    }
    associateId(r) {
      const request = r.toApiJson ? r : new AssociateIDRequest(r);
      return this.http.post(this._host + "/contacts.v1.Contacts/AssociateID", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    bulkCreate(r) {
      const request = r.toApiJson ? r : new BulkCreateContactRequest(r);
      return this.http.post(this._host + "/contacts.v1.Contacts/BulkCreate", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    bulkUpdate(r) {
      const request = r.toApiJson ? r : new BulkUpdateContactRequest(r);
      return this.http.post(this._host + "/contacts.v1.Contacts/BulkUpdate", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    triggerSync(r) {
      const request = r.toApiJson ? r : new TriggerSyncRequest(r);
      return this.http.post(this._host + "/contacts.v1.Contacts/TriggerSync", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
  }
  ContactsApiService.ɵfac = function ContactsApiService_Factory(t) {
    return new (t || ContactsApiService)(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(HostService));
  };
  ContactsApiService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: ContactsApiService,
    factory: ContactsApiService.ɵfac,
    providedIn: 'root'
  });
  return ContactsApiService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// API Service.
// *********************************
let CustomerIdMappingApiService = /*#__PURE__*/(() => {
  class CustomerIdMappingApiService {
    constructor(http, hostService) {
      this.http = http;
      this.hostService = hostService;
      this._host = this.hostService.hostWithScheme;
    }
    apiOptions() {
      return {
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        }),
        withCredentials: true
      };
    }
    get(r) {
      const request = r.toApiJson ? r : new GetCustomerIdMappingRequest(r);
      return this.http.post(this._host + "/contacts.v1.CustomerIdMappingService/Get", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetCustomerIdMappingResponse.fromProto(resp)));
    }
  }
  CustomerIdMappingApiService.ɵfac = function CustomerIdMappingApiService_Factory(t) {
    return new (t || CustomerIdMappingApiService)(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(HostService));
  };
  CustomerIdMappingApiService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: CustomerIdMappingApiService,
    factory: CustomerIdMappingApiService.ɵfac,
    providedIn: 'root'
  });
  return CustomerIdMappingApiService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// API Service.
// *********************************
let CustomerApiService = /*#__PURE__*/(() => {
  class CustomerApiService {
    constructor(http, hostService) {
      this.http = http;
      this.hostService = hostService;
      this._host = this.hostService.hostWithScheme;
    }
    apiOptions() {
      return {
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        }),
        withCredentials: true
      };
    }
    create(r) {
      const request = r.toApiJson ? r : new CreateCustomerRequest(r);
      return this.http.post(this._host + "/contacts.v1.CustomerService/Create", request.toApiJson(), this.apiOptions()).pipe(map(resp => CreateCustomerResponse.fromProto(resp)));
    }
    delete(r) {
      const request = r.toApiJson ? r : new DeleteCustomerRequest(r);
      return this.http.post(this._host + "/contacts.v1.CustomerService/Delete", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    update(r) {
      const request = r.toApiJson ? r : new UpdateCustomerRequest(r);
      return this.http.post(this._host + "/contacts.v1.CustomerService/Update", request.toApiJson(), this.apiOptions()).pipe(map(resp => UpdateCustomerResponse.fromProto(resp)));
    }
    get(r) {
      const request = r.toApiJson ? r : new GetCustomerRequest(r);
      return this.http.post(this._host + "/contacts.v1.CustomerService/Get", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetCustomerResponse.fromProto(resp)));
    }
    getMultiCustomers(r) {
      const request = r.toApiJson ? r : new GetMultiCustomersRequest(r);
      return this.http.post(this._host + "/contacts.v1.CustomerService/GetMultiCustomers", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetMultiCustomersResponse.fromProto(resp)));
    }
    list(r) {
      const request = r.toApiJson ? r : new ListCustomersRequest(r);
      return this.http.post(this._host + "/contacts.v1.CustomerService/List", request.toApiJson(), this.apiOptions()).pipe(map(resp => ListCustomersResponse.fromProto(resp)));
    }
    bulkCreate(r) {
      const request = r.toApiJson ? r : new BulkCreateCustomerRequest(r);
      return this.http.post(this._host + "/contacts.v1.CustomerService/BulkCreate", request.toApiJson(), this.apiOptions()).pipe(map(resp => BulkCreateCustomerResponse.fromProto(resp)));
    }
    listCustomerOrigins(r) {
      const request = r.toApiJson ? r : new ListCustomerOriginsRequest(r);
      return this.http.post(this._host + "/contacts.v1.CustomerService/ListCustomerOrigins", request.toApiJson(), this.apiOptions()).pipe(map(resp => ListCustomerOriginsResponse.fromProto(resp)));
    }
    syncCustomers(r) {
      const request = r.toApiJson ? r : new SyncCustomersRequest(r);
      return this.http.post(this._host + "/contacts.v1.CustomerService/SyncCustomers", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    desyncCustomers(r) {
      const request = r.toApiJson ? r : new DesyncCustomersRequest(r);
      return this.http.post(this._host + "/contacts.v1.CustomerService/DesyncCustomers", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    bulkUpdate(r) {
      const request = r.toApiJson ? r : new BulkUpdateCustomersRequest(r);
      return this.http.post(this._host + "/contacts.v1.CustomerService/BulkUpdate", request.toApiJson(), this.apiOptions()).pipe(map(resp => BulkUpdateCustomersResponse.fromProto(resp)));
    }
    createWithoutConflict(r) {
      const request = r.toApiJson ? r : new CreateWithoutConflictRequest(r);
      return this.http.post(this._host + "/contacts.v1.CustomerService/CreateWithoutConflict", request.toApiJson(), this.apiOptions()).pipe(map(resp => CreateWithoutConflictResponse.fromProto(resp)));
    }
  }
  CustomerApiService.ɵfac = function CustomerApiService_Factory(t) {
    return new (t || CustomerApiService)(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(HostService));
  };
  CustomerApiService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: CustomerApiService,
    factory: CustomerApiService.ɵfac,
    providedIn: 'root'
  });
  return CustomerApiService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// API Service.
// *********************************
let UserListApiService = /*#__PURE__*/(() => {
  class UserListApiService {
    constructor(http, hostService) {
      this.http = http;
      this.hostService = hostService;
      this._host = this.hostService.hostWithScheme;
    }
    apiOptions() {
      return {
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        }),
        withCredentials: true
      };
    }
    createUserList(r) {
      const request = r.toApiJson ? r : new CreateUserListRequest(r);
      return this.http.post(this._host + "/contacts.v1.UserList/CreateUserList", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    addUsersToList(r) {
      const request = r.toApiJson ? r : new AddUsersToListRequest(r);
      return this.http.post(this._host + "/contacts.v1.UserList/AddUsersToList", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    listUsersFromList(r) {
      const request = r.toApiJson ? r : new ListUsersFromListRequest(r);
      return this.http.post(this._host + "/contacts.v1.UserList/ListUsersFromList", request.toApiJson(), this.apiOptions()).pipe(map(resp => ListUsersFromListResponse.fromProto(resp)));
    }
    listUserLists(r) {
      const request = r.toApiJson ? r : new ListUserListsRequest(r);
      return this.http.post(this._host + "/contacts.v1.UserList/ListUserLists", request.toApiJson(), this.apiOptions()).pipe(map(resp => ListUserListsResponse.fromProto(resp)));
    }
    getUserList(r) {
      const request = r.toApiJson ? r : new GetUserListRequest(r);
      return this.http.post(this._host + "/contacts.v1.UserList/GetUserList", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetUserListResponse.fromProto(resp)));
    }
    deleteUserFromList(r) {
      const request = r.toApiJson ? r : new DeleteUserFromListRequest(r);
      return this.http.post(this._host + "/contacts.v1.UserList/DeleteUserFromList", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
  }
  UserListApiService.ɵfac = function UserListApiService_Factory(t) {
    return new (t || UserListApiService)(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(HostService));
  };
  UserListApiService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: UserListApiService,
    factory: UserListApiService.ɵfac,
    providedIn: 'root'
  });
  return UserListApiService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// API Service.
// *********************************
let VendorCustomerApiService = /*#__PURE__*/(() => {
  class VendorCustomerApiService {
    constructor(http, hostService) {
      this.http = http;
      this.hostService = hostService;
      this._host = this.hostService.hostWithScheme;
    }
    apiOptions() {
      return {
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        }),
        withCredentials: true
      };
    }
    vendorCreate(r) {
      const request = r.toApiJson ? r : new VendorCreateCustomerRequest(r);
      return this.http.post(this._host + "/contacts.v1.VendorCustomerService/VendorCreate", request.toApiJson(), this.apiOptions()).pipe(map(resp => VendorCreateCustomerResponse.fromProto(resp)));
    }
    vendorAssociateCustomerId(r) {
      const request = r.toApiJson ? r : new VendorAssociateCustomerIDRequest(r);
      return this.http.post(this._host + "/contacts.v1.VendorCustomerService/VendorAssociateCustomerID", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    vendorUpdate(r) {
      const request = r.toApiJson ? r : new VendorUpdateCustomerRequest(r);
      return this.http.post(this._host + "/contacts.v1.VendorCustomerService/VendorUpdate", request.toApiJson(), this.apiOptions()).pipe(map(resp => VendorUpdateCustomerResponse.fromProto(resp)));
    }
    vendorDelete(r) {
      const request = r.toApiJson ? r : new VendorDeleteCustomerRequest(r);
      return this.http.post(this._host + "/contacts.v1.VendorCustomerService/VendorDelete", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    vendorGet(r) {
      const request = r.toApiJson ? r : new VendorGetCustomerRequest(r);
      return this.http.post(this._host + "/contacts.v1.VendorCustomerService/VendorGet", request.toApiJson(), this.apiOptions()).pipe(map(resp => VendorGetCustomerResponse.fromProto(resp)));
    }
    vendorList(r) {
      const request = r.toApiJson ? r : new VendorListCustomersRequest(r);
      return this.http.post(this._host + "/contacts.v1.VendorCustomerService/VendorList", request.toApiJson(), this.apiOptions()).pipe(map(resp => VendorListCustomersResponse.fromProto(resp)));
    }
    vendorListCustomerOrigins(r) {
      const request = r.toApiJson ? r : new VendorListCustomerOriginsRequest(r);
      return this.http.post(this._host + "/contacts.v1.VendorCustomerService/VendorListCustomerOrigins", request.toApiJson(), this.apiOptions()).pipe(map(resp => VendorListCustomerOriginsResponse.fromProto(resp)));
    }
    vendorSyncAllCustomers(r) {
      const request = r.toApiJson ? r : new VendorSyncAllCustomersRequest(r);
      return this.http.post(this._host + "/contacts.v1.VendorCustomerService/VendorSyncAllCustomers", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
  }
  VendorCustomerApiService.ɵfac = function VendorCustomerApiService_Factory(t) {
    return new (t || VendorCustomerApiService)(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(HostService));
  };
  VendorCustomerApiService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: VendorCustomerApiService,
    factory: VendorCustomerApiService.ɵfac,
    providedIn: 'root'
  });
  return VendorCustomerApiService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// Index.
// *********************************
let CustomerService = /*#__PURE__*/(() => {
  class CustomerService {
    constructor(customerAPI) {
      this.customerAPI = customerAPI;
    }
    createCustomer(accountGroupId, partnerId, firstName, lastName, address, city, state, country, phoneNumbers, emailAddresses, tags, origins, permissionToContact) {
      return this.customerAPI.create({
        accountGroupId: accountGroupId,
        partnerId: partnerId,
        firstName: firstName,
        lastName: lastName,
        address: address,
        city: city,
        state: state,
        country: country,
        phoneNumbers: phoneNumbers,
        emailAddresses: emailAddresses,
        tags: tags,
        origins: origins,
        permissionToContact: permissionToContact
      });
    }
    updateCustomer(accountGroupId, customerId, firstName, lastName, address, city, state, country, phoneNumbers, emailAddresses, tags, origin, permissionToContact, fieldMask, assignedRepFirstName, assignedRepLastName) {
      return this.customerAPI.update({
        accountGroupId: accountGroupId,
        customerId: customerId,
        firstName: firstName,
        lastName: lastName,
        address: address,
        city: city,
        state: state,
        country: country,
        phoneNumbers: phoneNumbers,
        emailAddresses: emailAddresses,
        tags: tags,
        origin: origin,
        permissionToContact: permissionToContact,
        fieldMask: fieldMask,
        assignedRepFirstName: assignedRepFirstName,
        assignedRepLastName: assignedRepLastName
      });
    }
    bulkUpdateCustomers(accountGroupId, customerIds, permissionToContact) {
      return this.customerAPI.bulkUpdate({
        accountGroupId,
        customerIds,
        permissionToContact
      });
    }
    deleteCustomer(accountGroupId, customerId) {
      return this.customerAPI.delete({
        accountGroupId: accountGroupId,
        customerId: customerId
      });
    }
    getCustomer(accountGroupId, customerId) {
      return this.customerAPI.get({
        accountGroupId: accountGroupId,
        customerId: customerId
      });
    }
    getMultiCustomers(customerIdentifiers) {
      return this.customerAPI.getMultiCustomers({
        customerIdentifiers: customerIdentifiers
      });
    }
    listCustomers(accountGroupId, cursor, pageSize, searchTerm, filters, sortOptions) {
      return this.customerAPI.list({
        accountGroupId: accountGroupId,
        cursor: cursor,
        pageSize: pageSize,
        searchTerm: searchTerm,
        filters: filters,
        sortOptions: sortOptions
      });
    }
    bulkCreateCustomers(accountGroupId, partnerId, filePath, mapping) {
      return this.customerAPI.bulkCreate({
        partnerId: partnerId,
        accountGroupId: accountGroupId,
        filePath: filePath,
        mapping: mapping
      });
    }
    listCustomerOrigins(accountGroupId) {
      return this.customerAPI.listCustomerOrigins({
        accountGroupId: accountGroupId
      });
    }
    syncCustomers(accountGroupId, appId, customerIds) {
      return this.customerAPI.syncCustomers({
        accountGroupId,
        appId,
        customerIds
      });
    }
    desyncCustomers(accountGroupId, appId, customerIds) {
      return this.customerAPI.desyncCustomers({
        accountGroupId,
        appId,
        customerIds
      });
    }
  }
  CustomerService.ɵfac = function CustomerService_Factory(t) {
    return new (t || CustomerService)(i0.ɵɵinject(CustomerApiService));
  };
  CustomerService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: CustomerService,
    factory: CustomerService.ɵfac,
    providedIn: 'root'
  });
  return CustomerService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let UserListSdkService = /*#__PURE__*/(() => {
  class UserListSdkService {
    constructor(delegate) {
      this.delegate = delegate;
    }
    createUserList(partnerId, listName, listId) {
      const req = {
        partnerId: partnerId,
        listName: listName,
        listId: listId
      };
      return this.delegate.createUserList(req).pipe(map(resp => resp.status === 200));
    }
    addUsersToList(listId, userIds) {
      const req = {
        listId: listId,
        userIds: userIds
      };
      return this.delegate.addUsersToList(req).pipe(map(resp => resp.status === 200));
    }
    listUsersFromList(listId, cursor, pageSize) {
      const req = {
        listId: listId,
        pagingOptions: {
          cursor: cursor,
          pageSize: pageSize
        }
      };
      return this.delegate.listUsersFromList(req);
    }
    listUserLists(partnerId, cursor, pageSize) {
      const req = {
        partnerId: partnerId,
        pagingOptions: {
          cursor: cursor,
          pageSize: pageSize
        }
      };
      return this.delegate.listUserLists(req);
    }
    getUserList(listId) {
      const req = {
        listId: listId
      };
      return this.delegate.getUserList(req).pipe(map(r => r.userList));
    }
    deleteUserFromList(listId, userId) {
      const req = {
        listId: listId,
        userId: userId
      };
      return this.delegate.deleteUserFromList(req).pipe(map(resp => resp.status === 200));
    }
  }
  UserListSdkService.ɵfac = function UserListSdkService_Factory(t) {
    return new (t || UserListSdkService)(i0.ɵɵinject(UserListApiService));
  };
  UserListSdkService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: UserListSdkService,
    factory: UserListSdkService.ɵfac,
    providedIn: 'root'
  });
  return UserListSdkService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let ContactEmailService = /*#__PURE__*/(() => {
  class ContactEmailService {
    constructor(delegate) {
      this.delegate = delegate;
    }
    createContactMessage(accountGroupId, contactIds, subject, template, ccAddress, bccAddress, replyAddress) {
      const req = {
        accountGroupId: accountGroupId,
        contactIds: contactIds,
        subject: subject,
        template: template,
        ccAddress: ccAddress,
        bccAddress: bccAddress,
        replyAddress: replyAddress
      };
      return this.delegate.createContactMessage(req).pipe(map(resp => {
        return resp.responseMessage;
      }));
    }
  }
  ContactEmailService.ɵfac = function ContactEmailService_Factory(t) {
    return new (t || ContactEmailService)(i0.ɵɵinject(ContactEmailApiService));
  };
  ContactEmailService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: ContactEmailService,
    factory: ContactEmailService.ɵfac,
    providedIn: 'root'
  });
  return ContactEmailService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * Generated bundle index. Do not edit.
 */

export { AddUsersToListRequest, AssociateIDRequest, BulkCreateContactRequest, BulkCreateCustomerRequest, BulkCreateCustomerResponse, BulkCreateCustomerValidationError, BulkUpdateContactRequest, BulkUpdateCustomersRequest, BulkUpdateCustomersResponse, Conflict, ConflictingField, Contact, ContactEmailApiService, ContactEmailService, ContactMessageRequest, ContactMessageResponse, ContactsApiService, CreateContactRequest, CreateContactResponse, CreateCustomerRequest, CreateCustomerResponse, CreateUserListRequest, CreateWithoutConflictRequest, CreateWithoutConflictResponse, Customer, CustomerApiService, CustomerFieldType, CustomerFilters, CustomerHeaderMapping, CustomerIdMapping, CustomerIdMappingApiService, CustomerOrigin, CustomerService, CustomerSortDirection, CustomerSortField, CustomerSortOptions, CustomerType, CustomerValidationError, DateRangeFilter, DeleteContactRequest, DeleteCustomerRequest, DeleteUserFromListRequest, DesyncCustomersRequest, EntityType, FieldMask, Filters, GetCustomerIdMappingRequest, GetCustomerIdMappingResponse, GetCustomerRequest, GetCustomerResponse, GetMultiCustomersRequest, GetMultiCustomersRequestCustomerIdentifiers, GetMultiCustomersResponse, GetUserListRequest, GetUserListResponse, HeaderMapping, HostService, ListContactsRequest, ListContactsResponse, ListCustomerOriginsRequest, ListCustomerOriginsResponse, ListCustomersRequest, ListCustomersResponse, ListOriginsRequest, ListOriginsResponse, ListUserListsRequest, ListUserListsResponse, ListUsersFromListRequest, ListUsersFromListResponse, PagedRequestOptions, PagedResponseMetadata, ReviewRequestStatus, SortDirection, SortField, SortOptions, SyncCustomersRequest, TriggerSyncRequest, UpdateContactRequest, UpdateContactResponse, UpdateCustomerRequest, UpdateCustomerResponse, UserListApiService, UserListItem, UserListSdkService, VendorAssociateCustomerIDRequest, VendorCreateCustomerRequest, VendorCreateCustomerResponse, VendorCustomerApiService, VendorDeleteCustomerRequest, VendorGetCustomerRequest, VendorGetCustomerResponse, VendorListCustomerOriginsRequest, VendorListCustomerOriginsResponse, VendorListCustomersRequest, VendorListCustomersResponse, VendorSyncAllCustomersRequest, VendorUpdateCustomerRequest, VendorUpdateCustomerResponse, WhiteLabeledOrigin };
